
export default {
  lang(state, lang) {
    state.lang = lang
    localStorage.setItem('lang', lang.value)
  },
  feature(state, feature) {
    state.feature = feature
  },
  user(state, user) {
    localStorage.setItem('user', JSON.stringify(user))
    localStorage.setItem('token', user['token'])
    state.user = user
    state.token = user['token']
  },
  setService(state, service_name) {
    localStorage.setItem('service_name', service_name)
    state.service_name = service_name
  },
  setNavObj(state, nav_obj) {
    localStorage.setItem('nav_obj', JSON.stringify(nav_obj))
    state.nav_obj = nav_obj
  },
  setMiniVariant(state, mini) {
    state.mini_variant = mini
    localStorage.setItem('mini_variant', mini)
  },
  setOptions(state, options) {
    localStorage.setItem('options', JSON.stringify(options))
    state.options = options
  },
  payment_types(state, payment_types) {
    state.payment_types = payment_types
  },
  loyalty(state, loyalty) {
    state.loyalty = loyalty
  },
  tickets(state, tickets) {
    state.tickets = tickets
  },
  setItemsService(state, service) {
    state.items_current_service = service
    localStorage.setItem('items_current_service', JSON.stringify(service))
  },
  setStock(state, stock) {
    state.stock_item = stock
    localStorage.setItem('stock_item', JSON.stringify(stock))
  },
  setSupplier(state, supplier) {
    state.supplier1 = supplier
    localStorage.setItem('supplier1', JSON.stringify(supplier))
  },
  setStatus(state, status) {
    state.status1 = status
    localStorage.setItem('status1', JSON.stringify(status))
  },
  setType(state, type) {
    state.type_pur = type
    localStorage.setItem('type_pur', JSON.stringify(type))
  },
  setsuppValPage(state, page) {
    state.suppValPage = page
  },
  setCategory(state, category) {
    state.category1 = category
    localStorage.setItem('category1', JSON.stringify(category))
  },
  setItemsPage(state, page) {
    state.items_current_page = page
    localStorage.setItem('items_current_page', page)
  },
  setEmployeePage(state, page) {
    state.items_current_page = page
    localStorage.setItem('items_current_page', page)
  },
  setItemsLimit(state, limit) {
    state.items_current_limit = limit
    localStorage.setItem('items_current_limit', limit)
  },
  setAccess(state, access) {
    state.access = access
    localStorage.setItem('access', JSON.stringify(access))
  },
  serItemListHeaders(state, item_headers) {
    state.item_list_headers = item_headers
    localStorage.setItem('item_list_headers', JSON.stringify(item_headers))
  },
  setCurrentCurrency(state, value) {
    state.currentCurrency = value;
    localStorage.setItem('currentCurrency', value);
  },
  setCurrencyZeros(state, value) {
    state.currencyZeros = value;
    localStorage.setItem('currencyZeros', value);
  },
  signout(state) {
    state.user = null
    state.token = null
    localStorage.removeItem('user')
    localStorage.removeItem('token')
    localStorage.clear()
  },
  setItemSortBy(state, sort_by) {
    state.sort_by = sort_by;
    localStorage.setItem('sort_by', sort_by)
  },
  setReceiptNumber(state, receipt_number) {
    state.receipt_number = receipt_number;
    localStorage.setItem('receipt_number', receipt_number);
  },
  setReceiptLetter(state, receipt_letter) {
    state.receipt_letter = receipt_letter;
    localStorage.setItem('receipt_letter', receipt_letter);
  },
  setLastLabel(state, label) {
    state.lastLabel = label;
    localStorage.setItem('lastLabel', label);
  },
  set_supplier_id_for_item(state, id) {
    state.supplier_id_for_item = id
  }
}
